<template>
  <div>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-card-text>
                <div v-if="resetSent">
                  {{ $t("reset_success") }}
                  <a href="/login">{{ $t("reset_can_now_login")}}</a>
                </div>
                <div v-else-if="sendingReset">
                  <v-progress-circular
                    color="blue-grey"
                    indeterminate
                  ></v-progress-circular>
                </div>
                <v-form
                  v-else
                  ref="form"
                  v-model="valid"
                  v-on:submit.prevent="submitReset"
                >
                  <v-text-field
                    v-model="password1"
                    :type="'password'"
                    :rules="password1Rules"
                    :error-messages="password1Errors"
                    :label="$t('password')"
                    @change="validatePassword1"
                    required
                    autocomplete="new-password"
                  ></v-text-field>
                  <v-text-field
                    ref="password2"
                    v-model="password2"
                    :type="'password'"
                    :rules="password2Rules"
                    :error-messages="password2Errors"
                    :label="$t('password_verification')"
                    required
                    autocomplete="new-password"
                  ></v-text-field>

                  <v-btn class="primary" type="submit" :disabled="!valid">
                    {{ $t("reset_password") }}
                  </v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    <BackendConnector ref="backend"></BackendConnector>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "PasswordReset",
  components: {
  },
  data() {
    return {
      sendingReset: false,
      resetSent: false,
      valid: false,
      uid: "",
      token: "",
      password1: "",
      password1Rules: [
        v => !!v || this.$t("password_required"),
        v => v.length >= 8 || this.$t("password_at_least", ["8"])
      ],
      password1Errors: [],
      password2: "",
      password2Rules: [v => !!v || this.$t("password_required")],
      password2Errors: []
    }
  },
  methods: {
    submitReset() {
      if (this.$refs.form.validate()) {
        this.sendingReset = true;
        let url = process.env.VUE_APP_ROOT_API + "/rest-auth/reset/";
        let self = this;
        this.$refs.backend
          .post(url, {
            uid: this.uid,
            token: this.token,
            new_password1: this.password1,
            new_password2: this.password2,
          })
          .then(function(response) {
            if (response.status && (response.status === 201 || response.status === 200)) {
              self.sendingReset = false;
              self.resetSent = true;
            } else {
              //alert(JSON.stringify(response))
            }
          })
          .catch(function(error) {
            self.sendingReset = false;
            if (error.response.data && (error.response.new_password1 || error.response.new_password2)) {
              if (error.response.data.new_password1) {
                self.password1Errors = error.response.data.new_password1;
                self.valid = false;
              }
              if (error.response.data.new_password2) {
                self.password2Errors = error.response.data.new_password2;
                self.valid = false;
              }
            } else {
              alert(JSON.stringify(error.response));
            }
          });
      } else {
        alert("form not valid");
      }
    },
    checkPasswords() {
      if (this.password1 === this.password2) {
        this.password2Errors = [];
        this.valid = true;
        return true;
      } else {
        this.password2Errors = [this.$t("passwords_dont_match")];
        this.valid = false;
        return false;
      }
    },
    validatePassword1() {
      this.password1Errors = [];
    }
  },
  watch: {
    password2(val) {
      this.checkPasswords();
    }
  },
  mounted() {
    this.uid = this.$route.query.uid;
    this.token = this.$route.query.token;

    if (this.$i18n) {
      this.$i18n.locale = this.$store.getters.getLanguage;
    }
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case "LANG":
          if (this.$i18n) {
            this.$i18n.locale = mutation.payload;
          }
          break;
      }
    });
  }
};
</script>
